var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCool19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM5 8.33519C5 7.85596 5.35238 7.44966 5.82679 7.38189C7.57521 7.13211 9.35865 7.36799 10.982 8.06372L11.1904 8.15304C11.2531 8.1799 11.3117 8.2125 11.366 8.25H12.634C12.6883 8.2125 12.7469 8.1799 12.8096 8.15304L13.018 8.06372C14.6414 7.36799 16.4248 7.13211 18.1732 7.38189C18.6476 7.44966 19 7.85596 19 8.33519V11.1529C19 11.6417 18.6466 12.0589 18.1644 12.1393L17.644 12.226C16.5555 12.4074 15.4445 12.4074 14.356 12.226L13.6235 12.1039C13.2427 12.0404 12.9324 11.7634 12.8264 11.3922L12.3571 9.75H11.6429L11.1736 11.3922C11.0676 11.7634 10.7573 12.0404 10.3765 12.1039L9.64399 12.226C8.5555 12.4074 7.4445 12.4074 6.35601 12.226L5.8356 12.1393C5.35341 12.0589 5 11.6417 5 11.1529V8.33519ZM7.25 16C7.25 15.5858 7.58579 15.25 8 15.25H16C16.4142 15.25 16.75 15.5858 16.75 16C16.75 16.4142 16.4142 16.75 16 16.75H8C7.58579 16.75 7.25 16.4142 7.25 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCool19);
export default __webpack_public_path__ + "static/media/cool-19.c015c15c0309b442057b6296c3ec20ff.svg";
export { ForwardRef as ReactComponent };